/**
 *  Set Home URL based on User Roles
 */
const getHomeRoute = (role) => {
  switch (role) {
    case 'super_admin':
      return '/admin/dashboards';
    case 'camp_admin':
      return '/campadmin/home';
    case 'organization':
      return '/organization/home';
    case 'donor':
      return '/allcampaigns';
    default:
      return '/';
  }
};

export default getHomeRoute;
